import React, { useState } from 'react';
import './styles.css'
import { Collapse } from 'react-collapse'
import { AiOutlineSearch } from 'react-icons/ai'
import { NavLink } from 'react-router-dom'
import SideNav from './../../../components/SideNav'

export default function Tela_RI() {
    let [search, setSearch] = useState(false);
    return (
        <>
            <SideNav />
            <body id="Tela-RI">
                <div id="main-RI">
                    <div id="top-RI">
                        <Collapse isOpened={search}>
                            <input
                                type="text"
                                id="RI"
                                placeholder="pesquisa..."
                            />
                        </Collapse>
                        <AiOutlineSearch
                            size={'5vh'}
                            id="Icon-Search-RI"
                            onClick={() => setSearch(!search)}
                        />
                    </div>
                </div>
                <div id="welcome-RI">
                    <div id="title-RI">
                        <h2 id="RI">Seja Bem-vindo(a)!</h2>
                    </div>
                    <div>
                        <NavLink id="RI" to="/RI_Login"> <button id="RI">Login</button></NavLink>
                        <NavLink id="RI" to="/RI_Cadastro"><button id="RI">Cadastro</button></NavLink>
                    </div>
                </div>
            </body>

        </>
    );
}